import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gh-newsletter-dialog',
    templateUrl: 'newsletter-dialog.component.html',
    standalone: false
})

export class NewsletterDialogComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
